import React from "react";

const SearchInput = ({ value, onChange, placeholder = "Search..." }) => {
  return (
    <input
      type="text"
      name="hs-table-search"
      value={value}
      onChange={onChange}
      className="input w-[100%] md:w-[335px] lg:w-[335px]  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline px-3"
      placeholder={placeholder}
    />
  );
};

export default SearchInput;
